var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('card-item',{key:item.id,attrs:{"item":item,"column-meta":_vm.columnMeta,"action-meta":_vm.actionMeta,"showContextMenu":_vm.showContextMenu},on:{"rowAction":_vm.rowAction,"fieldAction":_vm.fieldAction}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ccfd76a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/CardList.vue
// module id = null
// module chunks = 